import { CountryCodes } from './country-codes';
import { canadaOptions, usOptions } from './state-codes';

const countryByStateCode = new Map<string, CountryCodes>([
  ...usOptions.map(({ value }) => [value, CountryCodes.USA] as const),
  ...canadaOptions.map(({ value }) => [value, CountryCodes.Canada] as const),
]);

/** Resolves the country a state or province code belongs to, or undefined when it isn't one. */
export const getCountryFromStateCode = (stateCode?: string): CountryCodes | undefined =>
  countryByStateCode.get(stateCode?.trim().toUpperCase() ?? '');
